import { render, staticRenderFns } from "./MitMenuHR.vue?vue&type=template&id=2d5a8967&scoped=true"
import script from "./MitMenuHR.vue?vue&type=script&lang=js"
export * from "./MitMenuHR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a8967",
  null
  
)

export default component.exports